import BannerSlide from '../shared/BannerSlider/BannerSlide'
import FeaturedCard from '../shared/FeaturedCard/FeaturedCard'
import TalkToSupportBanner from '../shared/TalkToSupport'
import HowItWorks from '../shared/HowItWorks'
import UniveralBanner from '../shared/UniversalBanner'
import doc from './doc.png'
import manwithlenspng from './manwithlens.png'
import { StyleContentWrapper } from '../commons/ContentWrapper/style'
import CoupleBidirectionCard from './CoupleBidirectionCard'
import AppShowCase from '../shared/AppShowCase/AppShowCase'
import Faq from '../shared/Faq'
import ContactUsBanner from '../shared/ContactusBanner'
import DownloadAppBanner from '../shared/DownloadAppBanner'
import Footer from '../Layout/Footer'
import { useSeoData } from '@pages/front/hook/useSeoData'
import { useFaqData } from '../hook/useFaqData'
import SeoHead from '../shared/SeoHead/SeoHead'
const ServicePage = () => {
  const seo = useSeoData('service-seo', 'serviceSeo')
  const faq = useFaqData('Services')
  return (
    <>
      <SeoHead seo={seo} />

      <BannerSlide />
      <FeaturedCard />
      <TalkToSupportBanner />
      <HowItWorks />
      <StyleContentWrapper stretch paddingLeft="20" paddingRight="20">
        <UniveralBanner
          title="Experts Doctors"
          subtitle="Lorem ipsum dolor sit amet consectetur. Tempus aliquet"
          bgColor="#e6f5fc"
          imgSrc={doc}
          titleColor="#44b7df"
          subtitleColor="#000000"
          hasButton={false}
        />

        <CoupleBidirectionCard
          imgSrc1="/servicesSvg/image5.svg"
          imgSrc2="/servicesSvg/iphonemockup1.svg"
          title1="Book Trusted Doctors & Health Services"
          title2="Certified Professionals, Expert Care You Can Count On"
          subtitle1={`Whether you need a trained nurse at home or a trusted rehabilitation center, we make it easy
to find and book the right care. Browse verified services near you and schedule support in just
a few taps. Personalized, professional healthcare — delivered where it's needed most.`}
          subtitle2={`Connect with qualified doctors and healthcare providers handpicked for their expertise and
reliability. Whether it's a consultation, in-home nursing, or rehabilitation support - get care
that's tailored to your needs and trusted by thousands.`}
        />

        <UniveralBanner
          title="Reliable Lab Tests"
          subtitle="Lorem ipsum dolor sit amet consectetur. Tempus aliquet"
          bgColor="#fdf0d2"
          imgSrc={manwithlenspng}
          titleColor="#b4821f"
          subtitleColor="#000000"
          hasButton={false}
        />
        <CoupleBidirectionCard
          imgSrc1="/servicesSvg/labtest.svg"
          imgSrc2="/servicesSvg/iphonemockup2.svg"
          title1="Book Lab Tests with Ease"
          title2="Trusted Tests, Recommended by Expert Doctors"
          subtitle1="Skip the clinic lines and schedule your lab tests from home. Choose your preferred time,
          location, and get results delivered directly to your app - quick, secure, and hassle-free."
          subtitle2="Get lab tests that are backed by medical expertise. Our doctors recommend only the tests you
          need - conducted by certified labs and delivered with precision. Safe, reliable, and always in
          your control."
        />

        <UniveralBanner
          title="Essential Health Care"
          subtitle="Lorem ipsum dolor sit amet consectetur. Tempus aliquet"
          bgColor="#d3ddff"
          imgSrc={manwithlenspng}
          titleColor="#262f77"
          subtitleColor="#000000"
          hasButton={false}
        />
        <CoupleBidirectionCard
          imgSrc1="/servicesSvg/labtest.svg"
          imgSrc2="/servicesSvg/image2.svg"
          title1="Professional, Compassionate Care - Right Where You Need It"
          title2="Comfortable Care, Professional Standards"
          subtitle1="mole persian series that out so at edent ane our erie crestinas
because quality care should be comfortable and convenient."
          subtitle2="Get the support you need, from professionals who care. Whether it's recovery, daily assistance,
or specialized care - we bring it home to you."
        />
      </StyleContentWrapper>
      <AppShowCase />
      <Faq faqData={faq} />
      <ContactUsBanner />
      <DownloadAppBanner />
      <Footer />
    </>
  )
}

export default ServicePage
